import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiSiteDesignComponent } from './fi-site-design.component';
import { UIRouterModule } from '@uirouter/angular';
import { FiSiteDesignStates } from './fi-site-design.states';
import { FiSiteDesignSettingsComponent } from './fi-site-design-settings/fi-site-design-settings.component';
import { FiSiteDesignBrandCardComponent } from './fi-site-design-settings/fi-site-design-brand-card/fi-site-design-brand-card.component';
import { FiSiteDesignBrandEditorModule } from '@fi-app/fi-site-design/fi-site-design-settings/fi-site-design-brand-editor/fi-site-design-brand-editor.module';
import { MatDividerModule } from '@angular/material/divider';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { FiSiteDesignHelperService } from '@fi-app/fi-site-design/fi-site-design-helper.service';
import { FiSiteDesignBrandDeleteConfirmDialogComponent } from './fi-site-design-settings/fi-site-design-brand-delete-confirm-dialog/fi-site-design-brand-delete-confirm-dialog.component';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiSiteDesignAccessItemCellComponent } from './fi-site-design-access-item-cell/fi-site-design-access-item-cell.component';
import { FiSiteDesignAccessItemComponent } from './fi-site-design-access-item/fi-site-design-access-item.component';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild(FiSiteDesignStates),
        FiSiteDesignBrandEditorModule,
        MatDividerModule,
        FiAppTextSharedModule,
        MatIconModule,
        MatMenuModule,
        MatCardModule,
        MatButtonModule,
        SelectSearchModule,
        InfoIconModule,
        FiProfileIconModule,
    ],
    declarations: [
        FiSiteDesignComponent,
        FiSiteDesignSettingsComponent,
        FiSiteDesignBrandCardComponent,
        FiSiteDesignBrandDeleteConfirmDialogComponent,
        FiSiteDesignAccessItemCellComponent,
        FiSiteDesignAccessItemComponent,
    ],
    providers: [FiSiteDesignHelperService],
    exports: [FiSiteDesignAccessItemComponent],
})
export class FiSiteDesignModule {}
